import { OUTLOOK_BEAUTIFIED_PREFIX } from './constants';

export function isBeautifulLinkBasedOnId(anchorElement: HTMLAnchorElement): boolean {
    return anchorElement.id && anchorElement.id.indexOf(OUTLOOK_BEAUTIFIED_PREFIX) === 0;
}

export function addBeautifiedPrefixToId(anchorElement: HTMLAnchorElement) {
    anchorElement.id = OUTLOOK_BEAUTIFIED_PREFIX + anchorElement.id;
}
